import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: theme.palette.gray80.main,
    width: "24px",
    height: "24px",
  },
  text: {
    color: theme.palette.gray80.main,
    paddingLeft: "19px",
  },
}));

export default useStyles;
